module.exports = __webpack_public_path__ + "static/media/route-man.76b1bfbc.webp";